import localeAntd from 'antd/es/locale/es_ES'
const messages = {
  'topBar.issuesHistory': 'Historial de Problemas',
  'topBar.projectManagement': 'Administración Proyecto',
  'topBar.typeToSearch': 'Buscar...',
  'topBar.findPages': 'Buscar Página...',
  'topBar.actions': 'Acciones',
  'topBar.status': 'Estado',
  'topBar.profileMenu.hello': 'Hola',
  'topBar.profileMenu.billingPlan': 'Facturación',
  'topBar.profileMenu.role': 'Roles',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Teléfono',
  'topBar.profileMenu.editProfile': 'Editar Perfil',
  'topBar.profileMenu.logout': 'Logout',
  'topBar.altoContraste': 'Alto contraste',
  'topBar.profileMenu.department': 'Departamento',
  'topBar.profileMenu.responsibleUser': 'Usuario responsable',
}

export default {
  locale: 'es-ES',
  localeAntd,
  localeMoment: 'es',
  messages,
}
